import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect'

export const UserIsAuthenticated = connectedRouterRedirect({
  redirectPath: '/',
  wrapperDisplayName: 'UserIsAuthenticated',
  authenticatedSelector: (state) => {
    // A redirect takes place within AuthActions::ValidateSession()
    return true
  },
})